const cardItems = [
  {
    tag: '独家',
    title: '某顶流练习生私生活混乱遭实锤，多名女生联合爆料',
    desc: '从聊天记录到酒店监控，完整证据链揭示惊人内幕',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20editorial%20photography%20of%20a%20broken%20spotlight%20on%20empty%20stage%20with%20scattered%20papers%2C%20deep%20shadows%2C%20neon%20green%20accent%20light%20leaking%20from%20behind%20curtains%2C%20mysterious%20atmosphere%2C%20high%20contrast%2C%20cinematic%20mood%2C%20gossip%20magazine%20aesthetic%2C%20dramatic%20lighting&width=600&height=800&seq=cards-deep-01&orientation=portrait',
  },
  {
    tag: '沸',
    title: '直播带货一姐偷税漏税细节曝光，金额远超此前传闻',
    desc: '税务部门内部文件流出，实际数字令人瞠目结舌',
    img: 'https://readdy.ai/api/search-image?query=A%20luxurious%20studio%20with%20ring%20lights%20turned%20off%2C%20scattered%20cosmetics%20on%20floor%2C%20dark%20dramatic%20shadows%2C%20neon%20green%20glow%20from%20phone%20screen%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20mysterious%20vibe%2C%20cleaning%20products%20background&width=600&height=800&seq=cards-deep-02&orientation=portrait',
  },
  {
    tag: '深度',
    title: '网红MCN机构内幕大起底：合同陷阱与天价违约金',
    desc: '多名签约博主现身说法，揭露行业灰色地带',
    img: 'https://readdy.ai/api/search-image?query=A%20stack%20of%20legal%20contracts%20with%20red%20stamps%20on%20dark%20wooden%20desk%2C%20dramatic%20overhead%20lighting%2C%20shadows%20and%20highlights%2C%20neon%20green%20pen%20accent%2C%20corporate%20intrigue%20aesthetic%2C%20editorial%20quality%2C%20dark%20moody%20tones&width=600&height=800&seq=cards-deep-03&orientation=portrait',
  },
  {
    tag: '追踪',
    title: '电竞圈连环塌房：从假赛到赌博，行业整顿风暴来袭',
    desc: '多名职业选手涉案，联盟紧急启动调查程序',
    img: 'https://readdy.ai/api/search-image?query=Empty%20esports%20arena%20with%20dimmed%20lights%2C%20gaming%20chairs%20in%20shadows%2C%20monitors%20displaying%20static%2C%20neon%20green%20accents%2C%20dramatic%20atmosphere%2C%20high%20contrast%20editorial%20photography%2C%20dark%20moody%20scene&width=600&height=800&seq=cards-deep-04&orientation=portrait',
  },
  {
    tag: '独家',
    title: '某知识博主学术造假风波升级，高校已启动调查',
    desc: '论文抄袭、学历造假疑云，百万粉丝博主面临信任危机',
    img: 'https://readdy.ai/api/search-image?query=Old%20library%20books%20scattered%20on%20dark%20floor%20with%20dramatic%20shadows%2C%20neon%20green%20highlight%20on%20torn%20pages%2C%20mysterious%20atmosphere%2C%20editorial%20quality%2C%20high%20contrast%2C%20academic%20intrigue%20theme%2C%20dark%20cinematic%20lighting&width=600&height=800&seq=cards-deep-05&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-20 md:py-28 bg-background-700">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950 mb-14">
          深度图文：本周必看黑料
        </h2>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide">
          {cardItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex-shrink-0 rounded-2xl overflow-hidden relative cursor-pointer group transition-all duration-500 ${
                idx === 0
                  ? 'w-[340px] md:w-[420px]'
                  : 'w-[260px] md:w-[300px] hover:w-[340px] md:hover:w-[380px]'
              }`}
              style={{ aspectRatio: '3/4' }}
            >
              <img
                src={item.img}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/20 to-transparent"></div>

              <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-950 text-[11px] font-bold">
                {item.tag}
              </span>

              <div className="absolute bottom-4 left-4 right-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-50 font-heading leading-snug">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-300 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}